import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import { Protected } from "@/components/Protected";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Scan from "@/pages/Scan";
import LocationPage from "@/pages/LocationPage";
import StaffProfilePublic from "@/pages/StaffProfilePublic";
import CustomerHome from "@/pages/CustomerHome";
import Leaderboard from "@/pages/Leaderboard";

import StaffDashboard from "@/pages/staff/StaffDashboard";
import StaffInbox from "@/pages/staff/StaffInbox";
import StaffProfileEdit from "@/pages/staff/StaffProfileEdit";

import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminLocations from "@/pages/admin/AdminLocations";
import AdminStaff from "@/pages/admin/AdminStaff";
import AdminQR from "@/pages/admin/AdminQR";
import AdminStats from "@/pages/admin/AdminStats";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />

            {/* Customer */}
            <Route path="/scan" element={<Scan />} />
            <Route path="/app" element={<CustomerHome />} />
            <Route path="/me" element={<CustomerHome />} />
            <Route path="/leaderboard" element={<Leaderboard />} />
            <Route path="/l/:id" element={<LocationPage />} />
            <Route path="/s/:id" element={<StaffProfilePublic />} />

            {/* Staff */}
            <Route path="/staff" element={<Protected roles={["staff"]}><StaffDashboard /></Protected>} />
            <Route path="/staff/inbox" element={<Protected roles={["staff"]}><StaffInbox /></Protected>} />
            <Route path="/staff/profile" element={<Protected roles={["staff"]}><StaffProfileEdit /></Protected>} />

            {/* Admin */}
            <Route path="/admin" element={<Protected roles={["admin"]}><AdminDashboard /></Protected>} />
            <Route path="/admin/locations" element={<Protected roles={["admin"]}><AdminLocations /></Protected>} />
            <Route path="/admin/staff" element={<Protected roles={["admin"]}><AdminStaff /></Protected>} />
            <Route path="/admin/qr" element={<Protected roles={["admin"]}><AdminQR /></Protected>} />
            <Route path="/admin/stats" element={<Protected roles={["admin"]}><AdminStats /></Protected>} />
          </Routes>
          <Toaster theme="dark" position="top-center" />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
